/** v0.3 (S-17 Design-H4) リリース通知に表示するチェンジログ。
 *  新しいリリースを通知したい場合は配列の先頭に追記し、CURRENT_VERSION を更新する。
 *  §8f実装乖離メモ (docs/design/v03-custom-roles.md) 参照: バックエンド永続化はせず、
 *  localStorage の閲覧済みフラグのみで「初回表示」を判定する簡易実装。 */
export type ChangelogEntry = {
  version: string;
  date: string;
  title: string;
  items: string[];
};

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: 'v0.3',
    date: '2026-08-04',
    title: '会社独自の権限ロールに対応しました',
    items: [
      '会社独自の「ロール」を作成し、機能・操作・アクセス範囲を自由に組み合わせて権限を設定できるようになりました (設定 > ロール管理)',
      'ユーザーには複数のロールを同時に割り当てられます',
      'サイドバーのメニューは、割り当てられた権限に応じて自動的に表示/非表示が切り替わります',
    ],
  },
];

export const CURRENT_CHANGELOG_VERSION = CHANGELOG[0]!.version;

const seenKey = (userId: string) => `misespark:changelog-seen:${userId}`;

/** このユーザーが最新のチェンジログをまだ見ていなければ true */
export const shouldShowChangelog = (userId: string): boolean => {
  try {
    return localStorage.getItem(seenKey(userId)) !== CURRENT_CHANGELOG_VERSION;
  } catch {
    return false; // Private Mode 等でlocalStorage不可の場合は毎回表示せず抑制する
  }
};

export const markChangelogSeen = (userId: string): void => {
  try {
    localStorage.setItem(seenKey(userId), CURRENT_CHANGELOG_VERSION);
  } catch {
    // 保存できなくても実害は「毎回表示される」だけなので無視する
  }
};
